import {Trip} from "./Trip";

import prislopPhoto from "../../assets/seniors/Prislop si Huniazi/prislop.jpeg";
import castelul from "../../assets/seniors/Prislop si Huniazi/castelul.jpg";
import pesteraBoca from "../../assets/seniors/Prislop si Huniazi/pesteraBoca.png";
import castel2 from "../../assets/seniors/Prislop si Huniazi/castel2.jpg";

import barsana from "../../assets/seniors/Traditii Maramures/barsana.png";
import mocanita from "../../assets/seniors/Traditii Maramures/mocanita.png";
import mm from "../../assets/seniors/Traditii Maramures/mm.png";
import cimitir from "../../assets/seniors/Traditii Maramures/cimitir.png";
import cazareMM1 from "../../assets/seniors/Traditii Maramures/cazare1.png";
import cazareMM2 from "../../assets/seniors/Traditii Maramures/cazare2.png";

import sambata1 from "../../assets/seniors/Tara Fagarasului/sambata1.png";
import sambata2 from "../../assets/seniors/Tara Fagarasului/sambata2.jpg";
import sinca1 from "../../assets/seniors/Tara Fagarasului/sinca1.jpg";
import sinca2 from "../../assets/seniors/Tara Fagarasului/sinca2.png";

import tuberoze1 from "../../assets/seniors/tuberoze/tuberoze1.jpg";
import hoghilag from "../../assets/seniors/tuberoze/hog.jpg";
import sighisoara1 from "../../assets/seniors/tuberoze/sighi1.png";
import sighisoara2 from "../../assets/seniors/tuberoze/sighi2.jpg";

import mogosoaia from "../../assets/seniors/conace/mogosoaia.jpg";
import potlogi from "../../assets/seniors/conace/potlogi.jpg";
import druganescu from "../../assets/seniors/conace/druganescu.png";
import samurcasesti from "../../assets/seniors/conace/samur.jpg";

import man1 from "../../assets/seniors/toplita/man1.jpg";
import cascada from "../../assets/seniors/toplita/cascada.png";
import man2 from "../../assets/seniors/toplita/man2.png";
import man3 from "../../assets/seniors/toplita/man3.png";

import acvariu from "../../assets/seniors/Istanbul/acvariu.jpg";
import bazar1 from "../../assets/seniors/Istanbul/bazar1.JPG";
import bazar2 from "../../assets/seniors/Istanbul/bazar2.JPG";
import moschee from "../../assets/seniors/Istanbul/moschee.jpg";
import moschee2 from "../../assets/seniors/Istanbul/moschee2.JPG";
import peisaj from "../../assets/seniors/Istanbul/peisaj.jpg";
import pisica from "../../assets/seniors/Istanbul/pisica.JPG";
import tramvai from "../../assets/seniors/Istanbul/tramvai.JPG";

export const prislop: Trip = {
    name: "Mănăstirea Prislop și Castelul Huniazilor",
    route: "Brașov - Prislop - Hunedoara - Orăștie",
    days: [
        [
            {
                locationName: "Mănăstirea Prislop",
            },
            {
                locationName: "Mormântul Părintelui Arsenie Boca",
            },
            {
                locationName: "Castelul Huniazilor",
            },
            {
                locationName: "Hanu’ Șurianu",
                details: "masa de prânz"
            },
        ]
    ],
    price: "180 lei",
    photos: [prislopPhoto, pesteraBoca, castelul, castel2],
    dates: [new Date(2026, 2, 15)],
    included: ["Transport cu autocar", "Ghid însoțitor", "Taxele de intrare la obiectivele prevăzute în program"],
    notIncluded: ["Masa la restaurant"],
    notes: `Uneori, avem nevoie doar de o zi în care să luăm o pauză de la agitaţia oraşului.
                    O zi în care să ne liniștim sufletul, să ne reculegem și să ne bucurăm de locuri cu adevărat speciale.
                    Vă propunem o excursie de o zi la Mănăstirea Prislop, loc de rugăciune și pace, unde vom avea timp pentru reculegere și pentru a ajunge la Mormântul Părintelui Arsenie Boca .
                    Apoi, ne continuăm drumul spre Castelul Huniazilor, unul dintre cele mai frumoase și impresionante castele din România, încărcat de istorie și legende. 
                    Vom face și un popas pentru masa de prânz la Hanu’ Șurianu (masa nu este inclusă).
                    `
};

export const maramuresWinterTraditions: Trip = {
    name: "Tradiții de iarnă în Maramureș",
    route: "Brașov - Poienile Izei - Mocănița - Cimitirul Vesel - Bârsana - Muzeul femeii maramureșence - Moara lui Niculai - Castelul Teleki",
    days: [
        // ziua 1
        [
            {
                locationName: "Castelul Teleki",
                details: "din Posmuş"
            },
            {locationName: "Muzeul Femeii Maramureşence"},
            {
                locationName: "Cina",
                details: "la cazare"
            }
        ],
        // ziua 2
        [
            {
                locationName: "Micul dejun",
                details: "la cazare"
            },
            {locationName: "Ritualul sacrificării porcului"},
            {
                locationName: "Pomana porcului",
                details: "masa de prânz"
            },
            {locationName: "Cimitirul Vesel"},
            {locationName: "Mănăstirea Săpânţa Peri"},
            {locationName: "Moara și pălincăria lui Niculai"},
            {
                locationName: "Cina",
                details: "la cazare"
            }
        ],
        // ziua 3
        [
            {
                locationName: "Micul dejun",
                details: "la cazare"
            },
            {
                locationName: "Mocănița din Maramureș",
                details: "Vișeul de Sus"
            },
            {
                locationName: "Prânzul",
                details: "în pădure, în stația Mocăniței"
            },
            {locationName: "Mănăstirea Bârsana"},
            {
                locationName: "Seară Maramureşeană cu ceteraşi şi dans",
                details: "include cina - la cazare"
            }

        ],
        // ziua 4
        [
            {
                locationName: "Micul dejun",
                details: "la cazare"
            },
            {locationName: "Mănăstirea Botiza"},
            {
                locationName: "Prânzul",
                details: "la restaurant, pe traseu"
            }
        ]
    ],
    price: "1550 lei",
    dates: [new Date(2026, 11, 10)],
    photos: [barsana, mocanita, mm, cimitir, cazareMM1, cazareMM2],
    included: ["Cazare în camere duble", "Mic dejun, prânz și cină", "Transport cu autocar", "Ghid însoțitor", "Taxele de intrare la obiectivele prevăzute în program"],
    notes: `Iarna în Maramureș nu este doar un anotimp, este o poveste trăită pe viu. Te invităm să descoperi un tărâm 
    unde tradițiile sunt păstrate cu sfințenie, oamenii te primesc cu sufletul deschis, iar zăpada așterne un farmec 
    aparte peste bisericile de lemn și satele de munte.
    Timp de 4 zile vei păși în inima autenticității românești și vei trăi experiențe pe care nu le uiți.\n
    Se pot efectua plecări din: Bucureşti, Ploieşti, Braşov, Sf. Gheorghe, Sibiu, Sighişoara, Tg.
    Mureş.\n
    Preţul diferă în funcție de oraşul de îmbarcare şi se va calcula la cerere. 
`
}

export const conaceBoieresti: Trip = {
    name: "Pe urmele lui Constantin Brâncoveanu – Conace Boiereşti de pe lângă Bucureşti",
    route: "Brașov - Mogoșoaia - Potlogi - Stoenești - Ciorogârla",
    price: "180 lei",
    photos: [mogosoaia, potlogi, druganescu, samurcasesti],
    dates: [new Date(2026, 3, 18)],
    days: [
        [
            {locationName: "Palatul Mogoşoaia"},
            {
                locationName: "Conacul Potlogi",
                details: "Reșesință a domnitorului Brâncoveanu"
            },
            {
                locationName: "Conacul Drugănescu",
                details: "Stoenești"
            },
            {
                locationName: "Mănăstirea Samurcăseşti",
                details: "Ciorogârla"
            },
        ]
    ],
    notes: `Vă invităm într-o călătorie culturală de o zi, dedicată descoperirii eleganței și rafinamentului 
        stilului brâncovenesc. Veți descoperi detalii din viața domnului Țării Românești, chiar în locurile unde acesta
         își ducea traiul. Apoi veți simți că părăsiți agitatul secol XXI și veți fi înconjurați de o liniște aparte și de
         tradiții în celelalte 2 opriri: Conacul Drugănescu și Mănăstirea Samurcășești.`
};

export const tuberoze: Trip = {
    name: "O zi în Tărâmul Tuberozelor",
    route: "",
    days: [
        [
            {
                locationName: "Festivalul Luberozelor",
                details: "Hoghilag"
            },
            {locationName: "Biserica Evanghelică Hoghilag"},
            {locationName: "Sighișoara"}
        ]
    ],
    price: "180 lei",
    photos: [tuberoze1, hoghilag, sighisoara1, sighisoara2],
    dates: [new Date(2026, 7, 9)],
    included: ["Transport cu autocar", "Ghid însoțitor", "Masa de prânz", "Taxele de intrare la obiectivele prevăzute în program"],
    notes: `Descoperă farmecul autentic al Transilvaniei într-o escapadă de neuitat! Participă la Festivalul Tuberozelor
     și lasă-te cucerit de parfumul inconfundabil al florilor, tradițiile locale și atmosfera vibrantă. Vizitează 
     cetatea medievală Sighișoara și admiră eleganța arhitecturală a Biserica Evanghelică din Hoghilag. O zi plină de 
     culoare, istorie și relaxare te așteaptă!
`
}

export const taraFagarasului: Trip = {
    name: "Excursie de o zi în inima Țării Făgărașului",
    route: "",
    days: [
        [
            {
                locationName: "Mănăstirea Sâmbăta de Sus",
                details: "(Mănăstirea Brâncoveanu)"
            },
            {
                locationName: "Mănăstirea Rupestră Șinca Veche",
                details: "Templul Ursitelor"
            }
        ]
    ],
    price: "60 lei",
    photos: [sambata1, sambata2, sinca1, sinca2],
    dates: [new Date(2026, 3, 26)],
    included: ["Transport cu autocar", "Ghid însoțitor", "Taxele de intrare la obiectivele prevăzute în program"],
    notIncluded: ["Masa la restaurant", "Suvenirurile"],
    notes: `Te invităm să descoperi două dintre cele mai liniștite locuri spirituale din zona Făgărașului – locuri 
    încărcate de istorie, credință și povești fascinante. O zi perfectă pentru relaxare, reculegere și descoperirea 
    unor locuri cu adevărat speciale.\n
    Mănăstirea Sâmbăta de Sus (Mănăstirea Brâncoveanu)
    Ascunsă la poalele Munților Făgăraș, această mănăstire a fost ridicată în anul 1696 de Constantin Brâncoveanu și a 
    devenit de-a lungul timpului un important centru spiritual al Transilvaniei. După ce a fost distrusă în perioada 
    habsburgică, mănăstirea a fost reconstruită în secolul XX și astăzi impresionează prin liniștea grădinilor, arhitectura 
    brâncovenească și izvorul considerat de mulți pelerini drept tămăduitor.\n
     Mănăstirea Rupestră Șinca Veche – Templul Ursitelor
    Un loc misterios, săpat direct în stâncă, despre care legendele spun că ar avea peste 7000 de ani. Aici, într-un spațiu 
    cu o energie aparte, se află o biserică rupestră cu simboluri neobișnuite și o deschidere în tavan prin care lumina
    cade direct în altar. Locul este învăluit în povești despre dorințe împlinite, liniște sufletească și spiritualitate
    profundă.
`
}

export const toplita: Trip = {
    name: "Toplița",
    route: "",
    days: [
        [
            {locationName: "Mănăstirea Doamnei"},
            {locationName: "Mănăstirea Toplița"},
            {locationName: "Cascada Mezotermală Toplița"},
        ]
    ],
    price: "190 lei",
    dates: [new Date(2026, 5, 28)],
    photos: [man1, cascada, man2, man3],
    included: ["Transport cu autocar", "Ghid însoțitor", "Masa de prânz", "Taxele de intrare la obiectivele prevăzute în program"],
    notes: `Te invităm să evadezi pentru o zi într-un colț de natură și spiritualitate, unde liniștea munților se îmbină perfect cu energia locurilor sfinte.
    Lasă orașul în urmă și oferă-ți o zi de liniște, natură și inspirație!
    Locurile sunt limitate, iar experiențele… de neuitat.`
}

export const istanbul: Trip = {
    name: "Istanbul - orașul în care Orientul întâlnește Europa!",
    route: "",
    days: [
        // ziua 1
        [
            {
                locationName: "Sosire în Istanbul și cazare la Hotel",
            },
            {
                locationName: "Cina",
                details: "la hotel"
            },
        ],
        // ziua 2
        [
            {
                locationName: "Micul dejun",
                details: "la hotel"
            },
            {
                locationName: "Tur pietonal în zona Piața Sultanahmet",
                details:
                    "Palatul Topkapı" +
                    ", Hagia Sofia" +
                    ", Hipodromul" +
                    ", Moscheea Albastră"
            },
            {
                locationName: "Timp liber pentru shopping și explorare",
                details: "în Marele Bazar"
            },
            {
                locationName: "Biserica Izvorul Tămăduirii și fabrica de pielărie"
            },
            {
                locationName: "Cina",
                details: "la hotel"
            },
        ],
        // ziua 3
        [
            {
                locationName: "Micul dejun la hotel"
            },
            {
                locationName: "Acvariul Floria"
            },
            {
                locationName: "Biserica de la Vlaherne și magazinul de dulciuri"
            },
            {
                locationName: "Tur Night Bus",
                details: "Istanbulul iluminat este o experiență aparte!"
            },
            {
                locationName: "Cina",
                details: "la hotel"
            },

        ],
        // ziua 4
        [
            {
                locationName: "Micul dejun",
                details: "la hotel"
            },
            {
                locationName: "Îmbarcare pe vaporaș",
            },
            {
                locationName: "Insula Prințului",
            },
            {
                locationName: "Seară turcească pe vapor",
                details: "muzică, dans și atmosferă autentică!"
            },
            {
                locationName: "Cina",
                details: "la hotel"
            },
        ],
        // ziua 5
        [
            {
                locationName: "Micul dejun",
                details: "la hotel"
            },
            {
                locationName: "Plecare înapoi spre Brașov"
            },
        ],

    ],
    price: "560 €",
    dates: [new Date(2026, 9, 2)],
    photos: [moschee2, bazar1, bazar2, moschee, peisaj, acvariu, pisica, tramvai],
    included: ["Transport cu autocar", "Ghid însoțitor", "Taxele de vizitare la obiectivele prevăzute în program", "Cazare cu mic-dejun și cină"],
    notes: `Imaginează-ți o dimineață în care admiri cupolele și minaretele Istanbulului, o plimbare prin străduțele pline de viață 
    ale Marelui Bazar, o croazieră pe Bosfor între două continente și seri în care orașul se aprinde în mii de lumini… ✨\n
    Te invităm într-o **excursie de 5 zile în Istanbul**, una dintre cele mai fascinante metropole ale lumii, unde istoria, cultura, 
    gastronomia și atmosfera orientală se întâlnesc într-un decor spectaculos.`
}